import { Injectable } from "@angular/core";
import { BaseBrandService, RestrictedSiteInfo } from "projects/core/app/services/abstracts/brand.service";
import { Constants } from "projects/core/constants";

@Injectable({
  providedIn: "root",
})
export class PatientBrandService extends BaseBrandService {
  public get restrictedSite(): RestrictedSiteInfo | null {
    const data = this._cacheService.getSession(Constants.RESTRICTED_SITE_STORAGE_KEY);
    if (data) return JSON.parse(data);
    return null;
  }

  public set restrictedSite(restrictedSiteInfo: RestrictedSiteInfo | null) {
    this._cacheService.setSession(Constants.RESTRICTED_SITE_STORAGE_KEY, JSON.stringify(restrictedSiteInfo));
  }
}
